import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

function FormularzEdycjaKlienta({ klient, onKlientEdited }) {
    const [imie, setImie] = useState(klient.imie || '');
    const [nazwisko, setNazwisko] = useState(klient.nazwisko || '');
    const [nrTelefonu, setNrTelefonu] = useState(klient.nr_telefonu || '');
    const [adresEmail, setAdresEmail] = useState(klient.adres_email || '');
    const [status, setStatus] = useState(klient.status || 'aktywny');
    const [rabat, setRabat] = useState(klient.rabat || 0);
    const [czyFirma, setCzyFirma] = useState(klient.czy_firma || false);
    const [nip, setNip] = useState(klient.nip || '');
    const [regon, setRegon] = useState(klient.regon || '');
    const [nrKonta, setNrKonta] = useState(klient.nr_konta || '');
    const [kontakt, setKontakt] = useState(
        (klient.kontakt !== null && klient.kontakt !== 0) ? klient.kontakt.toString() : ''
      );
    const [celKontaktu, setCelKontaktu] = useState(klient.cel_kontaktu || '');
    const [rezygnacjaZPrzegladow, setRezygnacjaZPrzegladow] = useState(klient.rezygnacja_z_przegladow || false);
    const [powodRezygnacji, setPowodRezygnacji] = useState(klient.powod_rezygnacji || '');
    const [notatkaKlient, setNotatkaKlient] = useState(klient.notatka || '');
    const [grupaKliencka, setGrupaKliencka] = useState(klient.grupa_kliencka || '');
    const [rodoPosprzedazowe, setRodoPosprzedazowe] = useState(klient.rodo_posprzedazowe || false);
    const [rodoMarketingowe, setRodoMarketingowe] = useState(klient.rodo_marketingowe || false);

    const [bledy, setBledy] = useState({});
    const [komunikat, setKomunikat] = useState('');

    const [kraj, setKraj] = useState('');
    const [miasto, setMiasto] = useState('');
    const [kodPocztowy, setKodPocztowy] = useState('');
    const [ulica, setUlica] = useState('');
    const [nrDomu, setNrDomu] = useState('');
    const [nrLokalu, setNrLokalu] = useState('');
    const [notatkaAdres, setNotatkaAdres] = useState('');
    const [adresId, setAdresId] = useState(null);
    const [bledyAdresu, setBledyAdresu] = useState({});

    useEffect(() => {
        const pobierzAdres = async () => {
            try {
                const token = localStorage.getItem('token');
                const adresyResponse = await axios.get(
                    `${API_URL}/adresy?id_klient=${klient.id_klient}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                if (adresyResponse.data.length > 0) {
                    const adres = adresyResponse.data[0];
                    setKraj(adres.kraj);
                    setMiasto(adres.miasto);
                    setKodPocztowy(adres.kod_pocztowy);
                    setUlica(adres.ulica);
                    setNrDomu(adres.nr_domu);
                    setNrLokalu(adres.nr_lokalu);
                    setNotatkaAdres(adres.notatka);
                    setAdresId(adres.id_adres);
                }
            } catch (error) {
                console.error('Błąd pobierania adresu:', error);
            }
        };

        pobierzAdres();
    }, [klient.id_klient]);

    const waliduj = () => {
        let tempBledy = {};
        if (!imie) {
            tempBledy.imie = 'Imię jest wymagane';
        }
        if (!nrTelefonu) {
            tempBledy.nrTelefonu = 'Numer telefonu jest wymagany';
        } else if (!nrTelefonu.match('^[0-9]{9,15}$')) {
            tempBledy.nrTelefonu = 'Nieprawidłowy numer telefonu';
        }
        if (adresEmail && !adresEmail.match('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[A-Za-z]{2,}$')) {
            tempBledy.adresEmail = 'Nieprawidłowy adres email';
        }
        if (!grupaKliencka.trim()) {
            tempBledy.grupaKliencka = 'Grupa kliencka jest wymagana';
          }          
        if (nip && !nip.match('^[0-9]{10,12}$')) {
            tempBledy.nip = 'Nieprawidłowy NIP';
        }
        if (regon && !regon.match('^[0-9]{9,14}$')) {
            tempBledy.regon = 'Nieprawidłowy REGON';
        }
    
        setBledy(tempBledy);
        return Object.keys(tempBledy).length === 0;
    };

    const walidujAdres = () => {
        let tempBledy = {};
        if (!kraj) {
            tempBledy.kraj = 'Kraj jest wymagany';
        }
        if (!miasto) {
            tempBledy.miasto = 'Miasto jest wymagane';
        }
        if (!kodPocztowy) {
            tempBledy.kodPocztowy = 'Kod pocztowy jest wymagany';
        } else if (!kodPocztowy.match(/^\d{2}-\d{3}$/)) {
            tempBledy.kodPocztowy = 'Nieprawidłowy format kodu pocztowego (np. 12-345)';
        }
        if (!ulica) {
            tempBledy.ulica = 'Ulica jest wymagana';
        }
        if (!nrDomu) {
            tempBledy.nrDomu = 'Numer domu jest wymagany';
        }
    

        setBledyAdresu(tempBledy);
        return Object.keys(tempBledy).length === 0;
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        const czyKlientZwalidowany = waliduj();
        const czyAdresZwalidowany = walidujAdres();
        try {
            const token = localStorage.getItem('token');
            await axios.put(
                `${API_URL}/klienci/${klient.id_klient}`,
                {
                    imie,
                    nazwisko,
                    nr_telefonu: nrTelefonu,
                    adres_email: adresEmail,
                    status,
                    rabat,
                    czy_firma: czyFirma,
                    nip,
                    regon,
                    nr_konta: nrKonta,
                    notatka: notatkaKlient,
                    kontakt: (kontakt === '' || kontakt === 0) ? null : kontakt,
                    cel_kontaktu: celKontaktu,
                    rezygnacja_z_przegladow: rezygnacjaZPrzegladow,
                    powod_rezygnacji: powodRezygnacji,
                    grupa_kliencka: grupaKliencka,
                    rodo_posprzedazowe: rodoPosprzedazowe,
                    rodo_marketingowe: rodoMarketingowe
                },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            if (adresId) {
                await axios.put(
                    `${API_URL}/adresy/${adresId}`,
                    {
                        kraj,
                        miasto,
                        kod_pocztowy: kodPocztowy,
                        ulica,
                        nr_domu: nrDomu,
                        nr_lokalu: nrLokalu,
                        notatka: notatkaAdres,
                        id_klient: klient.id_klient,
                    },
                    { headers: { Authorization: `Bearer ${token}` } }
                );
            } else {
                await axios.post(
                    `${API_URL}/adresy`,
                    {
                        kraj,
                        miasto,
                        kod_pocztowy: kodPocztowy,
                        ulica,
                        nr_domu: nrDomu,
                        nr_lokalu: nrLokalu,
                        notatka: notatkaAdres,
                        id_klient: klient.id_klient,
                    },
                    { headers: { Authorization: `Bearer ${token}` } }
                );
            }

            onKlientEdited({
                ...klient,
                imie,
                nazwisko,
                nr_telefonu: nrTelefonu,
                adres_email: adresEmail,
                status,
                rabat,
                czy_firma: czyFirma,
                nip,
                regon,
                nr_konta: nrKonta,
                notatka: notatkaKlient,
                kontakt: kontakt ? kontakt : null,
                cel_kontaktu: celKontaktu,
                rezygnacja_z_przegladow: rezygnacjaZPrzegladow,
                powod_rezygnacji: powodRezygnacji,
                grupa_kliencka: grupaKliencka,
                rodo_posprzedazowe: rodoPosprzedazowe,
                rodo_marketingowe: rodoMarketingowe,
            });
        } catch (error) {
            console.error('Błąd edycji klienta:', error);
        }
    };

    return (
        <div>
            <h2>Edytuj klienta</h2>
            <form onSubmit={handleSubmit}>
        <div>
            <label>Imię*:</label>
            <input type="text" value={imie} onChange={(e) => setImie(e.target.value)} />
            {bledy.imie && <p style={{ color: 'red' }}>{bledy.imie}</p>}
        </div>
        <div>
            <label>Nazwisko:</label>
            <input type="text" value={nazwisko} onChange={(e) => setNazwisko(e.target.value)} />
        </div>
        <div>
            <label>Nr telefonu*:</label>
            <input type="tel" value={nrTelefonu} onChange={(e) => setNrTelefonu(e.target.value)} />
            {bledy.nrTelefonu && <p style={{ color: 'red' }}>{bledy.nrTelefonu}</p>}
        </div>
        <div>
            <label>Adres email:</label>
            <input type="email" value={adresEmail} onChange={(e) => setAdresEmail(e.target.value)} />
            {bledy.adresEmail && <p style={{ color: 'red' }}>{bledy.adresEmail}</p>}
        </div>
        <div>
            <label>Status*:</label>
            <select value={status} onChange={(e) => setStatus(e.target.value)}>
                <option value="aktywny">Aktywny</option>
                <option value="nieaktywny">Nieaktywny</option>
                <option value="zablokowany">Zablokowany</option>
                <option value="zalega z płatnościami">Zalega z płatnościami</option>
            </select>
        </div>
        <div>
            <label>Rabat:</label>
            <input type="number" value={rabat} onChange={(e) => setRabat(parseInt(e.target.value))} />
        </div>

        <div>
            <label>Grupa kliencka*:</label>
            <input
                type="text"
                value={grupaKliencka}
                maxLength={50}
                onChange={e => setGrupaKliencka(e.target.value)}
            />
            {bledy.grupaKliencka && <p style={{color:'red'}}>{bledy.grupaKliencka}</p>}
            </div>

            {/* Zgody RODO */}
            <div>
            <label>
                <input
                type="checkbox"
                checked={rodoPosprzedazowe}
                onChange={e => setRodoPosprzedazowe(e.target.checked)}
                />
                Zgoda RODO po-sprzedażowe
            </label>
            </div>
            <div>
            <label>
                <input
                type="checkbox"
                checked={rodoMarketingowe}
                onChange={e => setRodoMarketingowe(e.target.checked)}
                />
                Zgoda RODO marketingowe
            </label>
            </div>

        <div>
            <label>
            Czy firma: 
            <input type="checkbox" checked={czyFirma} onChange={(e) => setCzyFirma(e.target.checked)} />
            </label>
        </div>
        {czyFirma && (
            <>
                <div>
                    <label>NIP:</label>
                    <input type="text" value={nip} onChange={(e) => setNip(e.target.value)} />
                    {bledy.nip && <p style={{ color: 'red' }}>{bledy.nip}</p>}
                </div>
                <div>
                    <label>REGON:</label>
                    <input type="text" value={regon} onChange={(e) => setRegon(e.target.value)} />
                    {bledy.regon && <p style={{ color: 'red' }}>{bledy.regon}</p>}
                </div>
                <div>
                    <label>Nr konta:</label>
                    <input type="text" value={nrKonta} onChange={(e) => setNrKonta(e.target.value)} />
                </div>
            </>
        )}

        <div>
                <label>Termin najbliższego kontaktu do klienta
                <input type='date' value={kontakt} onChange={(e) => setKontakt(e.target.value)} />
                </label>
            </div>

            <div>
                <label>Cel kontaktu do klienta
                <textarea value={celKontaktu} onChange={(e) => setCelKontaktu(e.target.value)} />
                </label>
            </div>

            <div>
                <label>Rezygnacja z przeglądów
                <input type='checkbox' checked={rezygnacjaZPrzegladow} onChange={(e) => setRezygnacjaZPrzegladow(e.target.checked)} />
                </label>
            </div>
            {rezygnacjaZPrzegladow && (
            <div>
                <label>Powód rezygnacji
                <textarea value={powodRezygnacji} onChange={(e) => setPowodRezygnacji(e.target.value)} />
                </label>
            </div>
            )}



        <div>
            <label>Notatka klienta:</label>
            <textarea value={notatkaKlient} onChange={(e) => setNotatkaKlient(e.target.value)} />
        </div>

        <div>
                <label>Kraj:</label>
                <input type="text" value={kraj} onChange={(e) => setKraj(e.target.value)} />
                {bledyAdresu.kraj && <p style={{ color: 'red' }}>{bledyAdresu.kraj}</p>}
            </div>
            <div>
                <label>Miasto:</label>
                <input type="text" value={miasto} onChange={(e) => setMiasto(e.target.value)} />
                {bledyAdresu.miasto && <p style={{ color: 'red' }}>{bledyAdresu.miasto}</p>}
            </div>
            <div>
                <label>Kod pocztowy:</label>
                <input type="text" value={kodPocztowy} onChange={(e) => setKodPocztowy(e.target.value)} />
                {bledyAdresu.kodPocztowy && <p style={{ color: 'red' }}>{bledyAdresu.kodPocztowy}</p>}
            </div>
            <div>
                <label>Ulica:</label>
                <input type="text" value={ulica} onChange={(e) => setUlica(e.target.value)} />
                {bledyAdresu.ulica && <p style={{ color: 'red' }}>{bledyAdresu.ulica}</p>}
            </div>
            <div>
                <label>Nr domu:</label>
                <input type="text" value={nrDomu} onChange={(e) => setNrDomu(e.target.value)} />
                {bledyAdresu.nrDomu && <p style={{ color: 'red' }}>{bledyAdresu.nrDomu}</p>}
            </div>
            <div>
                <label>Nr lokalu:</label>
                <input type="text" value={nrLokalu} onChange={(e) => setNrLokalu(e.target.value)} />
            </div>
            <div>
                <label>Notatka adres:</label>
                <input type="text" value={notatkaAdres} onChange={(e) => setNotatkaAdres(e.target.value)} />
            </div>

        <button type="submit">Zapisz</button>
    </form>
            {komunikat && <p>{komunikat}</p>}
        </div>
    );
}

export default FormularzEdycjaKlienta;